import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { CreditMovementType } from "../../../../api/graphql";
import { ShowString } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { ShowDateTime } from "../../../common/controls";
import { ShowMultiLine } from "../../../common/controls";
import { ShowReference } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type CreditMovementViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  typeOptions: { id: string; displayId: string }[];
  type: CreditMovementType;
  deltaValue?: { displayId: string; id: string } | null;
  delta: number;
  balanceAfterValue?: { displayId: string; id: string } | null;
  balanceAfter: number;
  movementAtValue?: { displayId: string; id: string } | null;
  movementAt: Date | null;
  detailValue?: { displayId: string; id: string } | null;
  detail: string;
  editionKeyValue?: { displayId: string; id: string } | null;
  editionKey: string;
  editionNameValue?: { displayId: string; id: string } | null;
  editionName: string;
  purchaseValue: { displayId: string; id: string } | null;
};

export const CreditMovementViewForm: React.FC<CreditMovementViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      typeOptions = [],
      type = "" as CreditMovementType,
      delta = 0,
      balanceAfter = 0,
      movementAt = null,
      detail = "",
      editionKey = "",
      editionName = "",
      purchaseValue,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupCreditMovementLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowString
                  value={
                    type
                      ? typeOptions.find((o: { id: string }) => o.id === type)
                          ?.displayId || type
                      : ""
                  }
                  label={langStore.CreditMovementTypeLabel}
                />
                <ShowNumber
                  value={delta}
                  label={langStore.CreditMovementDeltaLabel}
                />
                <ShowNumber
                  value={balanceAfter}
                  label={langStore.CreditMovementBalanceAfterLabel}
                />
                <ShowDateTime
                  value={movementAt}
                  label={langStore.CreditMovementMovementAtLabel}
                />
                <ShowMultiLine
                  value={detail}
                  label={langStore.CreditMovementDetailLabel}
                />
                <ShowMultiLine
                  value={editionKey}
                  label={langStore.CreditMovementEditionKeyLabel}
                />
                <ShowMultiLine
                  value={editionName}
                  label={langStore.CreditMovementEditionNameLabel}
                />
                <ShowReference
                  label={langStore.CreditMovementPurchaseLabel}
                  selectedValue={langStore.displayIdByLang(
                    purchaseValue?.displayId
                  )}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
